module.exports = __webpack_public_path__ + "static/media/globe.5cad8eae.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/globe.png
 ** module id = 319
 ** module chunks = 0
 **/